import { Select } from '@hue/design-system';
import { Outlet, useLocation, useNavigate } from '@tanstack/react-router';
import { useCompanyScope } from './company-context.js';
import { settingsBlocksVisibleTo, type CompanySectionPath } from './company-sections.js';

/// A casca de Configurações (ADR 0041): a engrenagem troca o menu principal pelas páginas de
/// configuração, sem criar uma segunda coluna dentro do conteúdo.
///
/// Configurações não é módulo: cada página continua do módulo dono, com a contratação e a
/// permissão dele. O menu só mostra o que a pessoa alcança — a mesma conta do menu principal —, e o
/// portão de cada página repete a conta para quem chegar pelo endereço.
///
/// No celular a gaveta também mostra esse menu, mas a lista de escolha permanece no alto da página
/// para trocar de seção sem precisar reabri-la. Uma fileira de dez abas rolaria para o lado.
export function CompanySettingsLayout() {
  const { company, can } = useCompanyScope();
  const navigate = useNavigate();
  const pathname = useLocation({ select: (location) => location.pathname });
  const blocks = settingsBlocksVisibleTo(can);
  const sections = blocks.flatMap((block) => block.sections);
  const current = sections.find((section) =>
    pathname.startsWith(`/companies/${company.key}/settings/${section.key}`),
  );

  return (
    <div className="min-w-0">
      <div className="mb-6 lg:hidden">
        <Select
          label="Configurações"
          value={current?.to ?? ''}
          options={blocks.flatMap((block) =>
            block.sections.map((section) => ({
              value: section.to,
              label: `${block.label} · ${section.label}`,
            })),
          )}
          onValueChange={(to) =>
            void navigate({ to: to as CompanySectionPath, params: { companyKey: company.key } })
          }
        />
      </div>

      <Outlet />
    </div>
  );
}
